var map = {
	"./agricultural.svg": 2042,
	"./animals.svg": 2043,
	"./book_separate_car.svg": 2044,
	"./building.svg": 2045,
	"./commercial.svg": 2046,
	"./containers_and_railway.svg": 2047,
	"./food.svg": 2048,
	"./household.svg": 2049,
	"./liquid.svg": 2050,
	"./loose.svg": 2051,
	"./manipulator.svg": 2052,
	"./moto.svg": 2053,
	"./moving.svg": 2054,
	"./outsized.svg": 2055,
	"./passing.svg": 2056,
	"./people.svg": 2057,
	"./rubbish.svg": 2058,
	"./special.svg": 2059,
	"./vehicle.svg": 2060,
	"./vehicle_and_parts.svg": 2061,
	"./water_transport.svg": 2062
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;



//////////////////
// WEBPACK FOOTER
// ./client/components/CategoryIcon ./~/svg-inline-loader?removeSVGTagAttrs=false!^\.\/.*\.svg$
// module id = 664
// module chunks = 0